import * as commonScripts from '../common'
import Glide from '@glidejs/glide'

const cmpHero = {
  component: null,
  resizeTimer: 0,

  init: function (element) {
    const _ = this
    _.component = element

    // If not in edit mode, then initialize the carousel
    if (!commonScripts.util.isEditMode()) {
      const carouselDiv = _.component.querySelector('.glide')
      if (carouselDiv) {
        const track = carouselDiv.querySelector('.glide__track')
        const autoplay = _.component.getAttribute('data-autoplay')
        let loop = _.component.getAttribute('data-loop')
        loop = loop ? loop.toLowerCase() : loop
        const options = {}
        options.gap = 0
        options.type = (loop === 'true') ? 'carousel' : 'slider'
        options.autoplay = (isNaN(autoplay) || autoplay === '0') ? false : (autoplay * 1000)
        options.rewind = false

        let slideCount = carouselDiv.querySelectorAll('.glide__slide');
        if (slideCount.length > 1) {

            const glide = new Glide(carouselDiv, options)
            glide.on('mount.after', (event) => {
              setTimeout(() => {
                _.updateTrack(track, glide)
              }, 500)
            })
    
            glide.on('run.after', (event) => {
              _.updateTrack(track, glide)
            })
    
            window.addEventListener('resize', (event) => {
              clearTimeout(_.resizeTimer)
              _.resizeTimer = setTimeout(() => {
                _.updateTrack(track, glide)
              }, 500)
            })
    
            glide.mount()

        } else{
          let bullets = carouselDiv.querySelector('.glide__bullets');
          if(bullets){
            bullets.style.display = 'none'
          }          
        }
      }
    }
  },

  updateTrack: function (track, glide) {
    track.style.height = glide._c.Html.slides[glide._i].offsetHeight + 'px'
  }

}

export default cmpHero
